var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_002-mail",
    "data-name": "002-mail",
    transform: "translate(0 -85.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362",
    transform: "translate(0 85.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M14.231,85.333H.769A.771.771,0,0,0,0,86.1v8.462a.772.772,0,0,0,.769.769H14.231A.772.772,0,0,0,15,94.564V86.1A.772.772,0,0,0,14.231,85.333Zm-.289.577-6,4.5a.8.8,0,0,1-.885,0l-6-4.5Zm-3.2,4.8,3.269,4.038.011.011H.983l.011-.011,3.269-4.038a.289.289,0,0,0-.448-.363l-3.237,4V86.27l6.135,4.6a1.377,1.377,0,0,0,1.577,0l6.135-4.6v8.072l-3.237-4a.289.289,0,0,0-.448.363Z",
    transform: "translate(0 -85.333)",
    fill: "#356bb0"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8003a4914e74f22616727ea541ae1e03.svg";
export { ForwardRef as ReactComponent };